const capitalize = (text = '', type = '') => {
	if (type == 'capitalize') {
		return text.toLowerCase().replace(/\b./g, function (a) {
			return a.toUpperCase();
		});
	} else {
		return text.charAt(0).toUpperCase() + text.slice(1).toLocaleLowerCase();
	}
};
export default capitalize;